import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PopularArticles from '../containers/PopularArticles';
import PromptContainer from '../containers/PromptContainer';
import TopicList from '../containers/TopicList';
import AuthPromptModal from '../containers/AuthPromptModal';

import { loadModalContainer } from '../../contactUs/actions/action-login-modal';
import Page from '../../lib/page';
import { trackPage } from '../../lib/analytics-helper';
import UrlResources from '../constants/UrlResources';

class HomePage extends Component {
  /**
   * Firing Paypal help guide L1 topic impression here
   * as the topic list component is rendering twice
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    const { isLoading, error, blacklistedMarketICFFlag } = this.props;
    // once the api has successful response and remote config set to true and experience is personal
    if (
      prevProps.isLoading !== isLoading &&
      !isLoading &&
      !error &&
      !blacklistedMarketICFFlag &&
      Page.getExpByUserType() === 'personal'
    ) {
      //  when paypal help guide L1 topic is enabled firing an impression event
      trackPage({ id: 'ICFL1Topic', link: `smarthelp-hcr-topic-list|${UrlResources.PAYPALGUIDE}` });
    }
  }

  render() {
    return (
      <div className="home-content-container">
        <PopularArticles />
        <div className="topic-list__grid">
          <TopicList />
        </div>
        <div className="prompt-container__grid">
          <PromptContainer />
        </div>
        <AuthPromptModal />
      </div>
    );
  }
}

HomePage.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  blacklistedMarketICFFlag: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isLoading: state.topicList.isLoading,
    error: state.topicList.error,
    isInputFocused: state.contactReason.isInputFocused,
    blacklistedMarketICFFlag: state.topicList.blacklistedMarketICFFlag,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loadModalContainer }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
